import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import AddMonitorBar from './AddMonitorBar';
import WatchlistStarterCards from './WatchlistStarterCards';
import { TRANSLATION_KEY } from '../constants';
import css from './WatchlistEmptyState.css';

const WatchlistEmptyState = ({ onSubmit, scheduleCron, onScheduleClick, submitting = false, error = null }) => {
    const [suggestion, setSuggestion] = useState(null);
    const pickSuggestion = useCallback(text => setSuggestion(prev => ({ text, seq: (prev?.seq ?? 0) + 1 })), []);

    return (
        <div className={css.emptyState}>
            <div className={css.title}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.TITLE`} />
            </div>
            <div className={css.subtitle}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUBTITLE`} />
            </div>
            <AddMonitorBar
                suggestion={suggestion}
                onSubmit={onSubmit}
                scheduleCron={scheduleCron}
                onScheduleClick={onScheduleClick}
                submitting={submitting}
                error={error}
                isEmptyVariant
            />
            <div className={css.suggestionsTitle}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUGGESTIONS_TITLE`} />
            </div>
            <WatchlistStarterCards onPick={pickSuggestion} />
        </div>
    );
};

WatchlistEmptyState.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    scheduleCron: PropTypes.string.isRequired,
    onScheduleClick: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
};

export default WatchlistEmptyState;
